export default __webpack_public_path__ + "static/sdg-1-6c1d19fbedfad43e98b960e5e9b1d630.png";